(function () {
  "use strict";

  function text(value) {
    return (value || "").toString().trim();
  }

  function setHidden(element, hidden) {
    if (element) element.hidden = hidden;
  }

  function escapeText(value) {
    return text(value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char];
    });
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text(value));
  }

  function collect(form) {
    return {
      name: text(form.elements.name && form.elements.name.value),
      email: text(form.elements.email && form.elements.email.value),
      orderNumber: text(form.elements.orderNumber && form.elements.orderNumber.value),
      message: text(form.elements.message && form.elements.message.value),
      company: text(form.elements.company && form.elements.company.value),
      confirmIntent: Boolean(form.elements.confirmIntent && form.elements.confirmIntent.checked),
      pageUrl: window.location.href,
      clientSubmittedAt: new Date().toISOString()
    };
  }

  function validate(data) {
    if (data.company) return "Die Anfrage konnte nicht verarbeitet werden.";
    if (data.name.length < 2) return "Bitte gib deinen Namen ein.";
    if (!validEmail(data.email)) return "Bitte gib eine gueltige E-Mail-Adresse ein.";
    if (data.orderNumber.length < 2) return "Bitte gib deine Bestellnummer ein.";
    if (!data.confirmIntent) return "Bitte bestaetige, dass du den Widerruf erklaeren moechtest.";
    return "";
  }

  function showError(box, message) {
    if (!box) return;
    box.textContent = message;
    setHidden(box, !message);
  }

  function renderSummary(form, data) {
    var box = form.querySelector("[data-toa-summary]");
    if (!box) return;
    var message = data.message || "Keine Nachricht angegeben";
    box.innerHTML = [
      ["Name", data.name],
      ["E-Mail", data.email],
      ["Bestellnummer", data.orderNumber],
      ["Nachricht", message]
    ].map(function (entry) {
      return "<dt>" + escapeText(entry[0]) + "</dt><dd>" + escapeText(entry[1]) + "</dd>";
    }).join("");
  }

  function setStep(form, step) {
    var stepOne = form.querySelector('[data-toa-step="1"]');
    var stepTwo = form.querySelector('[data-toa-step="2"]');
    var firstIndicator = form.querySelector('[data-toa-step-indicator="1"]');
    var secondIndicator = form.querySelector('[data-toa-step-indicator="2"]');
    setHidden(stepOne, step !== 1);
    setHidden(stepTwo, step !== 2);
    if (firstIndicator) firstIndicator.classList.toggle("is-active", step === 1);
    if (secondIndicator) secondIndicator.classList.toggle("is-active", step === 2);
  }

  function showResult(form, data) {
    var result = form.querySelector("[data-toa-result]");
    var stepOne = form.querySelector('[data-toa-step="1"]');
    var stepTwo = form.querySelector('[data-toa-step="2"]');
    var mailStatus = data.emailCustomerStatus || "";
    var detail = mailStatus === "sent"
      ? "<p>Eine Bestaetigungsmail wurde an deine E-Mail-Adresse gesendet.</p>"
      : mailStatus
        ? "<p>Der Widerruf ist eingegangen. Falls keine Bestaetigungsmail ankommt, bewahre bitte diese Eingangsnummer auf.</p>"
        : "<p>Wir senden dir eine Bestaetigung per E-Mail und bearbeiten die Anfrage.</p>";
    setHidden(stepOne, true);
    setHidden(stepTwo, true);
    if (!result) return;
    result.innerHTML =
      "<strong>Widerruf eingegangen</strong>" +
      "<p>Dein Widerruf wurde erfasst. Die Eingangsnummer lautet <b>" + escapeText(data.reference || "-") + "</b>.</p>" +
      detail;
    setHidden(result, false);
    result.focus();
  }

  function withdrawalFallbackMessage() {
    return "Der Widerruf wurde noch nicht automatisch uebermittelt, weil die technische Widerrufsannahme gerade nicht erreichbar ist. Bitte sende den Widerruf direkt per E-Mail an info@toa-kn.com.";
  }

  function buildFallbackMailto(data) {
    var subject = "Widerruf Bestellung " + (data.orderNumber || "");
    return "mailto:info@toa-kn.com?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(buildFallbackBody(data, ""));
  }

  function buildFallbackBody(data, reference) {
    var lines = [
      "Ich moechte den Widerruf fuer folgende Bestellung erklaeren:",
      ""
    ];
    if (reference) {
      lines.push("Eingangsnummer: " + reference, "");
    }
    lines.push(
      "Name: " + (data.name || ""),
      "E-Mail: " + (data.email || ""),
      "Bestellnummer: " + (data.orderNumber || "")
    );
    if (data.message) {
      lines.push("", "Nachricht / Grund:", data.message);
    }
    lines.push("", "Ich bestaetige, dass ich den Widerruf fuer die angegebene Bestellung erklaeren moechte.");
    return lines.join("\n");
  }

  function showSubmitFallback(box, data) {
    if (!box) return;
    box.innerHTML = "";
    var text = document.createElement("span");
    text.textContent = withdrawalFallbackMessage() + " ";
    var link = document.createElement("a");
    link.href = buildFallbackMailto(data);
    link.textContent = "Widerruf per E-Mail senden";
    box.appendChild(text);
    box.appendChild(link);
    setHidden(box, false);
  }

  function parseSubmitResponse(response) {
    return response.text().then(function (raw) {
      if (!raw) {
        return {
          response: response,
          body: { ok: false, error: withdrawalFallbackMessage() }
        };
      }
      try {
        return { response: response, body: JSON.parse(raw) };
      } catch (error) {
        return {
          response: response,
          body: { ok: false, error: withdrawalFallbackMessage() }
        };
      }
    });
  }

  function submitFinal(form, data) {
    var button = form.querySelector("[data-toa-submit]");
    var errorBox = form.querySelector("[data-toa-final-error]");
    var endpoint = form.getAttribute("data-endpoint") || "/apps/widerruf/submit";
    if (button && button.disabled) return;
    if (button) {
      button.disabled = true;
      button.textContent = "Widerruf wird gesendet...";
    }
    showError(errorBox, "");
    return fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(Object.assign({}, data, { confirmed: true }))
    }).then(parseSubmitResponse).then(function (result) {
      var response = result.response;
      var body = result.body || {};
      if (!response.ok || !body.ok) {
        throw new Error(body.error || withdrawalFallbackMessage());
      }
      showResult(form, body);
    }).catch(function (error) {
      showSubmitFallback(errorBox, data);
      if (button) {
        button.disabled = false;
        button.textContent = "Widerruf jetzt verbindlich absenden";
      }
    });
  }

  function initForm(form) {
    var reviewButton = form.querySelector("[data-toa-review]");
    var backButton = form.querySelector("[data-toa-back]");
    var errorBox = form.querySelector("[data-toa-error]");
    var currentData = null;

    if (reviewButton) {
      reviewButton.addEventListener("click", function () {
        var data = collect(form);
        var error = validate(data);
        showError(errorBox, error);
        if (error) return;
        currentData = data;
        renderSummary(form, data);
        setStep(form, 2);
      });
    }

    if (backButton) {
      backButton.addEventListener("click", function () {
        setStep(form, 1);
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var data = currentData || collect(form);
      var error = validate(data);
      if (error) {
        showError(form.querySelector("[data-toa-final-error]"), error);
        return;
      }
      submitFinal(form, data);
    });
  }

  function init() {
    document.querySelectorAll("[data-toa-withdrawal-form]").forEach(initForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();